import { apiService } from './apiService';
import { MaterialsCatalogDto, SubMaterialDto } from 'types/api.types';

const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
};

interface CreateSubMaterialPayload {
  name: string;
  description?: string;
  points?: number;
  sortOrder?: number;
}

export const getMaterialsCatalog = async (): Promise<MaterialsCatalogDto | null> => {
  try {
    return await apiService.get<MaterialsCatalogDto>('/admin/materials');
  } catch (error) {
    return null;
  }
};

export const createSubMaterial = async (
  parentId: number,
  payload: CreateSubMaterialPayload,
): Promise<SubMaterialDto | null> => {
  try {
    return await apiService.post<SubMaterialDto>(`/admin/materials/${parentId}/children`, payload);
  } catch (error) {
    console.error('Failed to create sub-material:', error);
    return null;
  }
};

export interface DeleteSubMaterialResult {
  success: boolean;
  errorMessage?: string;
}

export const deleteSubMaterial = async (childId: number): Promise<DeleteSubMaterialResult> => {
  try {
    await apiService.delete<void>(`/admin/materials/children/${childId}`);
    return { success: true };
  } catch (error) {
    console.error('Failed to delete sub-material:', error);
    return {
      success: false,
      errorMessage: getErrorMessage(error, 'Unable to remove sub-material.'),
    };
  }
};
